import apiService from './apiService';
import { getApiBaseUrl } from '../config/apiConfig';

const PREFIX = '/secteurs';

const secteursService = {
  async health() {
    return apiService.get(`${PREFIX}/health`);
  },

  async getZones(params = {}) {
    const res = await apiService.get(`${PREFIX}/zones`, params);
    return res.data?.zones ?? [];
  },

  async getZone(id) {
    const res = await apiService.get(`${PREFIX}/zones/${id}`);
    return res.data?.zone ?? null;
  },

  async getSecteurs() {
    const res = await apiService.get(`${PREFIX}/secteurs`);
    return res.data?.secteurs ?? [];
  },

  async getCommerciaux() {
    const res = await apiService.get(`${PREFIX}/commerciaux`);
    return res.data?.commerciaux ?? [];
  },

  buildEntreprisesQueryParams(params = {}) {
    const scalarKeys = ['page', 'limit', 'nom', 'codePostal', 'commune', 'caMin', 'caMax', 'sortField', 'sortDirection'];
    const arrayKeys = [
      'departement',
      'secteur',
      'sectionActivite',
      'trancheEffectif',
    ];

    const query = {};

    scalarKeys.forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null && value !== '') {
        query[key] = value;
      }
    });

    arrayKeys.forEach((key) => {
      const values = params[key];
      if (Array.isArray(values) && values.length > 0) {
        query[key] = values;
      }
    });

    return query;
  },

  async getEntreprises(params = {}) {
    const baseUrl = getApiBaseUrl();
    const url = new URL(`${baseUrl}${PREFIX}/entreprises-locales`);
    const query = this.buildEntreprisesQueryParams(params);

    Object.entries(query).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((item) => url.searchParams.append(`${key}[]`, item));
      } else {
        url.searchParams.set(key, value);
      }
    });

    const token = localStorage.getItem('auth_token') || localStorage.getItem('jwt_token');
    const headers = { Accept: 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;

    const response = await fetch(url.toString(), { headers });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.message || `Erreur API ${response.status}`);
    }

    const res = await response.json();
    return {
      entreprises: res.data?.entreprises ?? [],
      pagination: res.pagination ?? {},
      pageSizes: res.data?.page_sizes ?? [25, 50, 100, 150, 200],
      stats: res.data?.stats ?? null,
    };
  },

  async getEntreprise(id) {
    const res = await apiService.get(`${PREFIX}/entreprises-locales/${id}`);
    return res.data?.entreprise ?? null;
  },

  async getFilterOptions() {
    const res = await apiService.get(`${PREFIX}/entreprises-locales/filters`);
    return res.data ?? {};
  },

  async searchLocal(params = {}) {
    const res = await apiService.get(`${PREFIX}/search/local`, params);
    return res.data ?? {};
  },

  async searchExternal(params = {}) {
    const res = await apiService.get(`${PREFIX}/external/search`, params);
    return res.data ?? {};
  },

  async getExternalSources() {
    const res = await apiService.get(`${PREFIX}/external/sources`);
    return res.data ?? {};
  },

  async getDashboardV2Meta() {
    const res = await apiService.get(`${PREFIX}/dashboard/v2`);
    return res.data ?? {};
  },

  async getDashboardV2Stats({ vendeurs = ['__TOUS__'], secteur = '__TOUS__', pipeSource = 'both' } = {}) {
    const baseUrl = getApiBaseUrl();
    const url = new URL(`${baseUrl}${PREFIX}/dashboard/v2/stats`);

    vendeurs.forEach((v) => url.searchParams.append('vendeurs[]', v));
    if (secteur && secteur !== '__TOUS__') {
      url.searchParams.set('secteur', secteur);
    }
    url.searchParams.set('pipe_source', pipeSource);

    const token = localStorage.getItem('auth_token') || localStorage.getItem('jwt_token');
    const headers = { Accept: 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;

    const response = await fetch(url.toString(), { headers });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.message || `Erreur API ${response.status}`);
    }
    const res = await response.json();
    return res.data ?? {};
  },
};

export default secteursService;
